// Niveaux de gris
export const black = '#222222';
export const lightBlack = '#303030';
export const darkgray = '#606060';

export const gray = '#CCCCCC';
export const lightgray = '#EDEDED';
export const veryLightgray = '#8A8A8A';

export const darkwhite = '#F6F6F6';
export const white = '#ffffff';

// Couleurs
export const violet = '#6744C6';
export const red = '#6744C6';
export const blue = '#6744C6';
export const orange = '#6744C6';



// WEBPACK FOOTER //
// src/app/src/styles/colors.ts